import { parseModel } from "./SAxsModelMapper";

/** Parse a single subtraction from a LIST API call */
export function parseSubtractions2(subtractions) {
    let result = [];
    if (subtractions) {
        subtractions.forEach(subtraction => {
            let parsedSubtraction = {};

            parsedSubtraction.subtractionId = subtraction.subtractionId;

            if (subtraction.substractionToAbInitioModel3VOs && subtraction.substractionToAbInitioModel3VOs instanceof Array && subtraction.substractionToAbInitioModel3VOs.length > 0) {
                let abInitioModels = subtraction.substractionToAbInitioModel3VOs;
                parsedSubtraction.abInitioModels = [];
                abInitioModels.forEach(abInitioModel => {
                    if (abInitioModel.abinitiomodel3VO) {
                        abInitioModel = abInitioModel.abinitiomodel3VO
                        let parsedAbInitioModel = {};
                        parsedAbInitioModel.abInitioModelId = abInitioModel.abInitioModelId;

                        if (abInitioModel.averagedModel) {
                            let parsedAveragedModel = parseModel(abInitioModel.averagedModel)
                            parsedAbInitioModel.averagedModel = parsedAveragedModel;
                        }
                        if (abInitioModel.modelList3VO) {
                            let modelList = abInitioModel.modelList3VO;
                            let parsedModelList = {}
                            parsedModelList.modelListId = modelList.modelListId;
                            if (modelList.modeltolist3VOs && modelList.modeltolist3VOs instanceof Array && modelList.modeltolist3VOs.length > 0) {
                                let models = modelList.modeltolist3VOs;
                                let parsedModels = [];
                                models.forEach(model => {
                                    if (model.model3VO) { parsedModels.push(model.model3VO) }
                                })
                                parsedModelList.models = parsedModels;
                            }
                            parsedAbInitioModel.modelList = parsedModelList
                        }

                        if (abInitioModel.shapeDeterminationModel) {
                            let parsedShapeDeterminationModel = parseModel(abInitioModel.shapeDeterminationModel);
                            parsedAbInitioModel.shapeDeterminationModel = parsedShapeDeterminationModel
                        }

                        if (abInitioModel.rapidShapeDeterminationModel) {
                            let parsedRapidShapeDeterminationModel = parseModel(abInitioModel.rapidShapeDeterminationModel);
                            parsedAbInitioModel.rapidShapeDeterminationModel = parsedRapidShapeDeterminationModel
                        }

                        parsedSubtraction.abInitioModels.push(parsedAbInitioModel)
                    }
                });
            }
            result.push(parsedSubtraction);
        });
        return result;
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Saxs/SaxsSubtractionsMapper.js